require('./files/description');
require('./files/personalized-services-list');

require('../../sass/web/_description.scss');
require('../../sass/web/personalized_services_tool.scss');